import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import ClientNavbar from "../components/ClientNavbar";
import Footer from "../components/Footer";
import api from "../services/api";

import "../styles/categories.css";

function Categories() {
  const [categories, setCategories] = useState([]);
  const [exams, setExams] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchExams();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories");
      setCategories(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchExams = async () => {
    try {
      const response = await api.get("/exams");
      setExams(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ClientNavbar />

      <div className="categories-page">

        <div className="page-header">

          <h1>Browse Categories</h1>

          <p>
            Choose a category to explore available
            examination papers.
          </p>

        </div>

        <div className="categories-grid">

          {categories.map((category) => {

            const totalExams = exams.filter(
              (exam) => exam.category === category.name
            ).length;

            return (

              <div
                className="category-card"
                key={category.id}
              >

                <div className="category-icon">
                  📚
                </div>

                <h2>{category.name}</h2>

                <p>
                  {category.description ||
                    "Browse examination papers in this category."}
                </p>

                <div className="category-count">
                  {totalExams} Exams
                </div>

                <Link
                  to={`/exams?category=${encodeURIComponent(category.name)}`}
                  className="browse-btn"
                >
                  Browse Exams
                </Link>

              </div>

            );

          })}

        </div>

      </div>

      <Footer />
    </>
  );
}

export default Categories;